var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashCanGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#919191",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.26 6.652l-.678 9.503c-.058.819-.74 1.454-1.561 1.454H4.979c-.821 0-1.503-.635-1.561-1.454l-.679-9.503M.391 3.522H17.61M5.87 3.522V1.174c0-.432.35-.783.782-.783h4.696c.432 0 .782.35.782.783v2.348",
    transform: "translate(1 1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashCanGrey);
export default __webpack_public_path__ + "static/media/trash-can-grey.6681ad7f5de53c172f04f8734da972f1.svg";
export { ForwardRef as ReactComponent };